import {combineEpics, Epic} from 'redux-observable';
import {dqButtonClickedAction, dqButtonErrorAction, dqButtonLoadingAction, dqButtonResponseAction, fetchDqButtonsAction, resetDqButtonsAction} from 'module/DqButton/action/DqButtonsAction';
import {fetchDqButtonResultAPI, fetchDqButtonsAPI} from 'module/DqButton/api/DqButtonAPI';
import {catchError, filter, map, mergeMap, switchMap, throttleTime} from 'rxjs/operators';
import {alertServerError, catchServerError} from 'module/ConfirmDialog/component/ConfirmDialogContainer';
import {concat, from, of} from 'rxjs';
import {selSharedAppState} from 'module/SharedAppState/selector/SharedAppStateSelector'

const fetchEpic: Epic = (action$, state$) => action$.pipe(
	filter(fetchDqButtonsAction.match),
	switchMap(({payload}) =>
		from(fetchDqButtonsAPI()).pipe(
			map(({data}) => resetDqButtonsAction(data)),
			catchServerError(),
		),
	),
)

const clickEpic: Epic = (action$, state$) => {
	return action$.pipe(
		filter(dqButtonClickedAction.match),
		throttleTime(2000),
		mergeMap(({payload: {dqButton, params}}) =>
			concat(
				of(dqButtonLoadingAction({dqButton})),
				from(fetchDqButtonResultAPI(dqButton.dqKey, {...selSharedAppState(state$.value), ...params})).pipe(
					map((response) => {
						const result = response.data.elements?.map(x => x.value)
						return dqButtonResponseAction({dqButton, result, data: response.data})
					}),
					catchError((error?: any) => {
						void alertServerError(error)
						return [dqButtonErrorAction({dqButton, error})]
					}),
				),
			),
		),
	);
}

export const DqButtonEpic = combineEpics(fetchEpic, clickEpic)